import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';


//Editor de um canal de curva bezier no formato usado pelo motor de particulas:
//  { type:'BEZIER', scale:1, bezierPoints:[ {x,y,percentage}, ... ] }
//Recebe a lista de pontos por @Input e devolve a lista alterada por @Output.
//O componente pai e o dono do FormArray; este componente so edita a lista plana.
@Component({
    selector : 'particle-curve',
    templateUrl:'particleCurve.html'
})
export class ParticleCurveComponent implements OnInit{

  @Input() points:any[]=[];
  @Input() label:string='';
  @Input() scale:number=1;
  @Input() minValue:number=0;
  @Input() maxValue:number=1;
  @Output() pointsChange=new EventEmitter<any[]>();

  public editing=false;

  public constructor() {
  }

  public ensurePoints(){
    if (!this.points){
      this.points=[];
    }
    return this.points;
  }
  public isEditing(){
    return this.editing;
  }
  public toggleEdit(){
    this.editing=!this.editing;
  }
  public sortedPoints(){
    let list=(this.points ? this.points.slice() : []);
    list.sort((a,b)=>{
      return (Number(a.percentage)||0)-(Number(b.percentage)||0);
    })
    return list;
  }
  //pontos do grafico, ja ordenados por percentage e normalizados na area do svg (0..1)
  public chartPath(){
    let list=this.sortedPoints();
    if (list.length==0){
      return '';
    }
    let steps=20;
    let d='';
    for (let i=0;i<=steps;i++){
      let t=i/steps;
      let y=this.valueAt(t);
      let px=(t*100).toFixed(2);
      let py=(100-(this.normalize(y)*100)).toFixed(2);
      d=d+(i==0 ? 'M' : 'L')+px+','+py+' ';
    }
    return d;
  }
  public normalize(value){
    let min=Number(this.minValue);
    let max=Number(this.maxValue);
    let n=Number(value);
    if (max==min){
      return 0;
    }
    let r=(n-min)/(max-min);
    if (r<0){return 0}
    if (r>1){return 1}
    return r;
  }
  //interpolacao linear entre os pontos (e o que o grafico desenha entre os keyframes)
  public valueAt(percentage){
    let list=this.sortedPoints();
    if (list.length==0){
      return 0;
    }
    if (percentage<=Number(list[0].percentage)){
      return Number(list[0].y);
    }
    if (percentage>=Number(list[list.length-1].percentage)){
      return Number(list[list.length-1].y);
    }
    for (let i=0;i<list.length-1;i++){
      let a=list[i];
      let b=list[i+1];
      let pa=Number(a.percentage);
      let pb=Number(b.percentage);
      if (percentage>=pa && percentage<=pb){
        let span=pb-pa;
        if (span==0){
          return Number(b.y);
        }
        let t=(percentage-pa)/span;
        return Number(a.y)+(Number(b.y)-Number(a.y))*t;
      }
    }
    return Number(list[list.length-1].y);
  }
  public addPoint(){
    let list=this.ensurePoints().slice();
    //insere um ponto na maior lacuna existente
    let sorted=list.slice().sort((a,b)=>{
      return (Number(a.percentage)||0)-(Number(b.percentage)||0);
    })
    let percentage=1;
    let lastY=0;
    if (sorted.length>0){
      let bestGap=-1;
      let left=sorted[0];
      let right=null;
      for (let i=0;i<sorted.length-1;i++){
        let gap=Number(sorted[i+1].percentage)-Number(sorted[i].percentage);
        if (gap>bestGap){
          bestGap=gap;
          left=sorted[i];
          right=sorted[i+1];
        }
      }
      let gapToEnd=1-Number(sorted[sorted.length-1].percentage);
      if (gapToEnd>bestGap){
        percentage=Number(sorted[sorted.length-1].percentage)+(gapToEnd/2);
        lastY=Number(sorted[sorted.length-1].y);
      }
      else{
        percentage=(Number(left.percentage)+Number(right.percentage))/2;
        lastY=(Number(left.y)+Number(right.y))/2;
      }
    }
    list.push({x:0,y:lastY,percentage:Number(percentage.toFixed(4))});
    this.emit(list);
  }
  public removePoint(point){
    let list=this.ensurePoints().slice();
    let idx=list.indexOf(point);
    if (idx<0){
      return;
    }
    list.splice(idx,1);
    this.emit(list);
  }
  public onFieldChange(){
    this.emit(this.ensurePoints());
  }
  public emit(list){
    let clean=[];
    list.forEach(p=>{
      clean.push({
        x: p.x==null || p.x==='' || isNaN(Number(p.x)) ? 0 : Number(p.x),
        y: p.y==null || p.y==='' || isNaN(Number(p.y)) ? 0 : Number(p.y),
        percentage: p.percentage==null || p.percentage==='' || isNaN(Number(p.percentage)) ? 0 : Number(p.percentage)
      })
    })
    this.points=clean;
    this.pointsChange.emit(clean);
  }

  public ngOnInit(): any {
    this.editing=false;
  }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/particleCurve.ts